module.exports = __webpack_public_path__ + "static/media/25.c1ab6d4b.jpg";